module.exports = __webpack_public_path__ + "img/avaccc.08803b0d.png";